import { styled } from '@vw-marketing/us-components';

export const StyledAppContainer = styled.div`
  min-height: 200px;
  width: 100%;
`;

export const StyledBulletList = styled.ul`
  margin-left: 0;
  padding-left: 1em;
  list-style-type: none;

  li:before {
    display: inline-block;
    content: '—';
    width: 1em;
  }
`;

export const StyledBulletListItem = styled.li`
  color: gray;
`;

export const StyledContainer = styled.div`
  padding: 30px 0;
`;
